import tw from 'twin.macro';
import styled from '@emotion/styled';

export const ResetButton = tw.button`bg-red-400 disabled:cursor-not-allowed cursor-pointer hover:bg-red-700 text-white font-bold py-2 px-4 rounded my-5 w-full`;
export const SubmitButton = styled.button`
  ${tw`disabled:bg-gray-400 disabled:cursor-not-allowed cursor-pointer bg-blue-500 text-white font-bold py-2 px-4 rounded my-5 w-full`}

  &[aria-disabled=true] {
    ${tw`bg-gray-400 cursor-not-allowed`}
  }
`;
